import Header from './components/Header';
import { isTouch } from './helpers/detect-device';
import { scrollTo } from './helpers/scroll-to';
import { $ } from './helpers/query';

export default () => {
  if (isTouch()) {
    document.body.classList.add('is-touch');
  }

  const header = new Header();
  header.init();

  scrollTo({
    offset: 120
  });

  $('.fade-in__elem').each(elem => {
    const isFooter = !!elem.closest('.footer');
    const wrapperSel = isFooter ? '.footer' : '.fade-in__container';
    const offset = isFooter ? '90%' : '80%';
    $(elem).scrollTrigger({
      triggerSel: wrapperSel,
      triggerPoint: offset,
      callback: elem => {
        $(elem).removeClass('fade-in__start');
        const duration = parseFloat($(elem).getCss('transition-duration'));
        const delay = parseFloat($(elem).getCss('transition-delay'));
        setTimeout(() => {
          $(elem).removeClass('fade-in__elem');
          for (let i = 1; i < 20; i++) {
            // $(elem).removeClass(`fade-in__order-${i}`);
            // $(elem).removeClass(`fade-in__order-lg-${i}`);
            // $(elem).removeClass(`fade-in__order-md-${i}`);
            // $(elem).removeClass(`fade-in__order-sm-${i}`);
          }
        }, (duration + delay) * 1000)
      }
    });
  });
}
